import React from 'react';

const SeismicIcon = () => {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.0059 0.669847L4.79215 2.51527C4.75368 2.52311 4.71918 2.5442 4.69466 2.57485C4.67014 2.60551 4.65714 2.64379 4.65793 2.68304V6.2229C4.65714 6.26214 4.67014 6.30043 4.69466 6.33108C4.71918 6.36174 4.75368 6.38282 4.79215 6.39066L14.0059 8.23609C14.0304 8.24098 14.0558 8.2403 14.0801 8.23409C14.1044 8.22788 14.127 8.2163 14.1463 8.20021C14.1655 8.18411 14.1809 8.16391 14.1913 8.14109C14.2017 8.11826 14.2068 8.0934 14.2063 8.06832V0.835096C14.2064 0.810232 14.201 0.785655 14.1905 0.763144C14.1799 0.740633 14.1645 0.72075 14.1453 0.704935C14.1261 0.68912 14.1036 0.677767 14.0795 0.671699C14.0554 0.665631 14.0302 0.664998 14.0059 0.669847Z"
        fill="#a3a3a2"
      />
      <path
        d="M1.99385 15.3299L11.2067 13.4845C11.2453 13.4768 11.28 13.4558 11.3047 13.4251C11.3294 13.3944 11.3425 13.3561 11.3418 13.3167V9.77936C11.3425 9.73999 11.3294 9.70161 11.3047 9.67094C11.28 9.64027 11.2453 9.61926 11.2067 9.61159L1.99385 7.76617C1.96925 7.76127 1.94387 7.76195 1.91957 7.76816C1.89527 7.77437 1.87267 7.78595 1.85344 7.80204C1.8342 7.81814 1.81882 7.83834 1.80842 7.86117C1.79803 7.88399 1.79288 7.90886 1.79337 7.93393V15.1638C1.79314 15.1887 1.79847 15.2134 1.80897 15.236C1.81948 15.2586 1.83489 15.2786 1.8541 15.2945C1.8733 15.3104 1.89581 15.3219 1.91998 15.328C1.94416 15.3341 1.96939 15.3348 1.99385 15.3299Z"
        fill="#a3a3a2"
      />
    </svg>
  );
};

export default SeismicIcon;
